import Cookies from 'js-cookie';
import { LANGUAGES, LOCALES } from './header/HeaderLanguages';
export const replace = (text, subs) => {
    const params = text.match(/\${(.*?)}/g) || [];
    return params.reduce((result, param) => {
        return result.replace(param, subs[param.slice(2, -1)]);
    }, text);
};
export const matches = (a, b) => {
    const keys = Object.keys(a);
    for (const key of keys) {
        if (!Object.prototype.hasOwnProperty.call(b, key) || a[key] !== b[key]) {
            return false;
        }
    }
    return true;
};
export const getPathSegment = (path, customerType, app) => {
    if (customerType && app !== 'public') {
        return customerType === 'B2B' ? 'ari' : 'era';
    }
    const segmentFromPath = resolveSegmentFromPath(path);
    switch (segmentFromPath) {
        case 'eraklient':
        case 'chastnyj':
            return 'era';
        case 'ariklient':
        case 'biznes':
            return 'ari';
        default:
            return ['era', 'ari'].includes(segmentFromPath) ? segmentFromPath : '';
    }
};
export const resolveSegmentFromPath = (path) => {
    return path.replace(/^(\/(et|ru|en)\/)?\/?(([^/]*)|())(.*)$/gi, '$3');
};
export const toHeaderSegment = (segment, useCookie = true) => {
    switch (segment) {
        case 'era':
            return 'private';
        case 'ari':
            return 'business';
        default: {
            const segmentFromCookie = Cookies.get('segment');
            return !useCookie ? null : segmentFromCookie ? cookieSegmentToHeaderSegment(segmentFromCookie) : '';
        }
    }
};
export const cookieSegmentToHeaderSegment = (segmentFromCookie) => {
    return segmentFromCookie.toLowerCase() === 'b2b' ? 'business' : 'private';
};
export const isPreferencesCookieAllowed = () => {
    var _a;
    return (_a = Cookies.get('CookieConsent')) === null || _a === void 0 ? void 0 : _a.includes('preferences:true');
};
const getWithStartingSlash = (pathname) => {
    return pathname.startsWith('/') ? pathname : `/${pathname}`;
};
const getPathFromUrl = (url) => {
    const link = document.createElement('a');
    link.href = url;
    return toPath(getWithStartingSlash(link.pathname));
};
export const getWithEndingSlash = (pathname) => {
    return pathname.endsWith('/') ? pathname : `${pathname}/`;
};
export const getPathnameWithoutLang = (url) => {
    let path = getPathFromUrl(url);
    path = pathWithoutLang(path);
    return toPathname(path);
};
export const toPathnameWithEndingSlash = (url) => {
    const path = getPathFromUrl(url);
    const pathname = toPathname(path);
    return getWithEndingSlash(pathname);
};
export const pathnameWithoutLang = (pathname) => {
    return toPathname(pathWithoutLang(toPath(pathname)));
};
const pathWithoutLang = (path) => {
    return pathStartsWithLang(path) ? path.slice(1) : path;
};
export const toPath = (pathname) => {
    return pathname.split('/').filter((path) => path);
};
export const toPathname = (path) => {
    return `/${path.join('/')}`;
};
export const langFromPathname = (pathname) => {
    return langFromPath(toPath(pathname));
};
export const langToLocale = (lang) => {
    return LOCALES.get(lang);
};
export const decodeHtml = (html) => {
    return html && decodeURIComponent(html);
};
const langFromPath = (path) => {
    return pathStartsWithLang(path) ? path[0] : null;
};
const pathStartsWithLang = (path) => {
    return path && path.length > 0 && LANGUAGES.includes(path[0]);
};
const cloudinaryUrlWithSize = (size, url, srcSet = false) => {
    if (!url) {
        return '';
    }
    let imageLocation = 'telia-pim';
    ['http', 'https'].forEach((protocol) => {
        if (url.includes(`${protocol}://res.cloudinary.com/telia-pim/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia-pim/image/upload/`, '');
        }
        else if (url.includes(`${protocol}://res.cloudinary.com/telia-dev/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia-dev/image/upload/`, '');
            imageLocation = 'telia-dev';
        }
        else if (url.includes(`${protocol}://res.cloudinary.com/telia-test/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia-test/image/upload/`, '');
            imageLocation = 'telia-test';
        }
    });
    if (url.startsWith('/upload')) {
        url = url.substr('/upload'.length + 1);
    }
    return `https://res.cloudinary.com/${imageLocation}/image/upload/ar_1,c_pad,b_white/f_auto,fl_lossy,q_auto:best,w_${size}/${url}${srcSet ? ` ${size}w` : ''}`;
};
export const getImageSrcset = (sizes, url) => {
    return sizes.map((size) => cloudinaryUrlWithSize(size, url, true)).join(',');
};
export const setIsFromSelfServiceCookie = (value) => {
    Cookies.set('isFromSelfService', `${value}`, { domain: '.telia.ee' });
};
export const getIsFromSelfServiceCookie = () => {
    return Cookies.get('isFromSelfService') === 'true';
};
export const segmentToCookieMap = (key) => {
    switch (key) {
        case 'era':
            return 'b2c';
        case 'ari':
            return 'b2b';
        default:
            return 'general';
    }
};
export const cookieToSegmentMap = (key) => {
    switch (key) {
        case 'b2c':
            return 'era';
        case 'b2b':
            return 'ari';
        default:
            return '';
    }
};
export const isMyTeliaUserAgent = () => {
    return window.navigator.userAgent.includes('Context:WebView;App:MyTelia');
};
//# sourceMappingURL=utils.js.map